<div class="flex flex-col" *transloco="let t">
   <h2 class="text-3xl font-bold">{{ t('privacy.title') }}</h2>
   <div>{{ t('privacy.page') }}</div>
</div>
